import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';
import {Config} from '../config';
import { Observable } from 'rxjs/Observable';



@Injectable()
export class TranslationsService {
  public backendUrl: any = new Config();

  private langName = new Subject<any>();
  langName$ = this.langName.asObservable();

  headersRate = new Headers({'Content-Type': 'text/xml; charset=utf-8'});
  rateData = `<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    <soap:Body>
    <ExchangeRatesLatest xmlns="http://www.cba.am/" />
    </soap:Body>
    </soap:Envelope>`;

  constructor(private http: Http) {
    if ( localStorage.getItem('lang')) {
      this.langName.next(localStorage.getItem('lang'));
    }else {
      localStorage.setItem('lang', 'arm');
      this.langName.next(localStorage.getItem('lang'));
    }
  }

  getRate(): Observable<any> {
    return this.http.post(this.backendUrl.backendUrl + 'rate/get', this.rateData, {headers: this.headersRate}).map(res => res.json());
  }

  setLang(lang) {
    this.langName.next(lang) ;
  }

  getTranslations() {
    return this.http.get(this.backendUrl.backendUrl + 'languages/getTRanslates').map(res => res.json());
  }

  getLanguages() {
    return this.http.get(this.backendUrl.backendUrl + 'languages/getAll').map( (response ) => response.json());
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/services/translations.service.ts